import { render, staticRenderFns } from "./AutocompleteDisplay.vue?vue&type=template&id=517b663a"
import script from "./AutocompleteDisplay.vue?vue&type=script&lang=js"
export * from "./AutocompleteDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports